import React from 'react';
import TransactionsAllManagement from "../all/TransactionsAllManagement";

const TransactionAllTab = () => {
    return (
        <>
            <TransactionsAllManagement />
        </>
    );
};

export default TransactionAllTab;
